// extracted by mini-css-extract-plugin
module.exports = {"listWrap":"bind-record_listWrap_1tl77","imageContent":"bind-record_imageContent_1AnGs","empty":"bind-record_empty_3xGdc","emptyIcon":"bind-record_emptyIcon_2B15E"};